import { render, staticRenderFns } from "./SignDocumentPage.vue?vue&type=template&id=dd0523fc&scoped=true"
import script from "./SignDocumentPage.vue?vue&type=script&lang=js"
export * from "./SignDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0523fc",
  null
  
)

export default component.exports